import React from "react";
import styled from "styled-components";
import { ReactComponent as EmptyBox } from "../../../assets/icons/EmptyBox.svg";
import { theme } from "../../../theme";

interface Props {
  description?: string;
}
const EmptyBoxComp: React.FC<Props> = ({ description }) => {
  return (
    <StyledWrapper>
      <EmptyBox />
      <StyledText>{description || "결과가 없습니다."}</StyledText>
    </StyledWrapper>
  );
};
export default EmptyBoxComp;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 34px;
  background-color: white;
  border-radius: 0 0 8px 8px;
`;
const StyledText = styled.div`
  margin-top: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.gray2};
`;
